exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "ul.timeline .timeline-badge .glyphicon {\n  top: 2px; }\n\n@media only screen and (min-width: 768px) {\n  ul.timeline li .timeline-panel {\n    width: calc(50% - 45px);\n    width: -moz-calc(50% - 45px);\n    width: -webkit-calc(50% - 45px); } }\n\n@media only screen and (max-width: 767px) {\n  ul.timeline li .timeline-panel {\n    width: calc(100% - 85px);\n    width: -moz-calc(100% - 85px);\n    width: -webkit-calc(100% - 85px); } }\n", ""]);

// exports
